import { Button } from "@vds/buttons";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { DropdownSelect } from "@vds/selects";
import { patchWidgetConfig, selectedTimerData } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { patchAccountDetails } from "../../api/SessionServiceManager";
const TimerWidgetModal = ({
  showTimerModal,
  setShowTimerModal,
  widgetTimer,
}) => {
const selectedTimerDataDropdown = useSelector((state) => state.widgetReducer.selectedTimerValue);
const { activeSession } = useSelector(
  (state) => state.sessionReducer.activeSession
);
 const [selectedTimer, setSelectedTimer] = useState("")
  const dispatch = useDispatch()

  const timerData = [
    { key: "Last 10 min", value: "Last 10 minutes", intValue: 10 * 60 * 1000 },
    { key: "Last 15 min", value: "Last 15 minutes", intValue: 15 * 60 * 1000 },
    { key: "Last 30 min", value: "Last 30 minutes", intValue: 30 * 60 * 1000 },
    { key: "Last 1 hour", value: "Last 1 hour", intValue: 60 * 60 * 1000 },
    { key: "Last 4 hrs", value: "Last 4 hours", intValue: 4 * 60 * 60 * 1000 }
  ];

  return (
    <Modal
      opened={showTimerModal}
      onOpenedChange={(opened) => {
        setShowTimerModal(opened);
      }}
      surface="light"
      fullScreenDialog={false}
      disableAnimation={false}
      disableOutsideClick={false}
      ariaLabel="Testing Modal"
    >
      <ModalTitle>Change Time Range</ModalTitle>
      <ModalBody>
        Select the time range to be reported by the Statistics widget.
        <br />
        <br />
        <DropdownSelect
          label="Time Range"
          errorText="At least one type should be selected"
          error={false}
          readOnly={false}
          value={selectedTimer !== "" ? selectedTimer : selectedTimerDataDropdown}
          onChange={(e) => {setSelectedTimer(e.target.value)}} 
          width="100%"
          data-testid= "dashboard_widgetTimeRangeModalSelectDropdown"
        >
          {timerData.map((item) => (
            <option
              key={item?.value}
              selected={selectedTimerDataDropdown === item?.value}
            >
              {item.value}
            </option>
          ))}
        </DropdownSelect>
       
      </ModalBody>
      <ModalFooter
        buttonData={{
          primary: {
            width: "100%",
            'data-testid': 'dashboard_widgetTimeRangeModalPrimaryButton',
            children: "Set range",
            onClick: () => {
              const timerInInteger =
                timerData?.find((timer) => timer?.value === selectedTimer)
                  ?.intValue ?? 10 * 60 * 1000;
              dispatch(
                patchWidgetConfig({
                  customdata: {
                    widgettimerange: timerInInteger,
                  },
                })
              );
              dispatch(
                selectedTimerData(
                  selectedTimer !== ""
                    ? selectedTimer
                    : selectedTimerDataDropdown
                )
              );
              widgetTimer();
            },
          },
          close: {
            width: "100%",
            'data-testid': 'dashboard_widgetTimeRangeModalSecondaryButton',
            children: "Cancel",
          },
        }}
      />
    </Modal>
  );
};

export default TimerWidgetModal;
